import PropTypes from 'prop-types';
import React from 'react';
import '../assets/stats.scss';
import { Col, Progress, Row, Statistic, Tooltip } from 'antd';
import { withTranslation } from 'react-i18next';

import money from '../../../helpers/money';
import { transactionStatuses } from '../../../helpers/constants';

const calculateTotalAmount = (records, currency) => {
  if (records.length < 1) {
    return 0;
  }

  return records
    .map((row) => money.toInt(row.amount, currency, false))
    .reduce((curr, next) => curr + next);
};

const BatchStats = (props) => {
  const { t } = props;
  const countProcessed = (items) => items.filter(({ status }) => !!status).length;
  const countSuccesses = (items) => items.filter(({ status }) => (status === transactionStatuses.success)).length;
  const countFailures = (items) => items.filter(({ status }) => (status === transactionStatuses.failed)).length;
  const items = props.items || [];
  const processed = (props.processed || (props.processed === 0)) ? props.processed : countProcessed(items);
  const ok = (props.ok || (props.ok === 0)) ? props.ok : countSuccesses(items);
  const nok = (props.nok || (props.ok === 0)) ? props.nok : countFailures(items);
  const processedPercent = Math.floor((processed * 100) / items.length);
  const okNokPercent = Math.floor(((ok + nok) * 100) / processed);
  const currency = items.map((row) => row.currency)[0];
  const amount = calculateTotalAmount(items, currency);
  const balance = (props.balance || null);
  return (
    <Row style={{ marginTop: '20px' }} type="flex" justify="space-around" align="middle">
      <Col xs={12} sm={12} md={8} lg={8} xl={8}>
        <Tooltip title={`${processed} done / ${(processed - items.length)} to do`}>
          <Progress
            style={{ width: '100%', textAlign: 'center' }}
            percent={processedPercent}
            width={150}
            type="dashboard"
            format={() => (
              <Statistic
                title={t('processed')}
                value={processed}
                suffix={`/ ${items.length}`}
              />
            )}
          />
        </Tooltip>
      </Col>
      <Col xs={12} sm={12} md={8} lg={8} xl={8}>
        <Tooltip title={`${ok} successful / ${nok} errors`}>
          <Progress
            style={{ width: '100%', textAlign: 'center' }}
            width={150}
            percent={okNokPercent}
            strokeColor="red"
            type="dashboard"
            successPercent={Math.floor((ok * 100) / processed)}
            format={() => (
              <Statistic
                title={t('successful')}
                value={ok}
                suffix={`/ ${processed}`}
              />
            )}
          />
        </Tooltip>
      </Col>

      <Col xs={24} sm={24} md={8} lg={8} xl={8}>
        <Statistic
          className="batch-stats"
          title={t('total_amount')}
          value={money.toDisplay(amount, currency)}
          suffix={(balance) ? (<><br /> / ${balance}</>) : ('')}
        />
      </Col>
    </Row>
  );
};

BatchStats.propTypes = {
  balance: PropTypes.string,
  items: PropTypes.array,
  nok: PropTypes.any,
  ok: PropTypes.number,
  processed: PropTypes.number,
  t: PropTypes.func,
};

export default withTranslation()(BatchStats);
